import React from 'react';
import SingleDates from '../../../SingleDates/SingleDates';
import AnnualDates from '../../../AnnualDates/AnnualDates';
import './TravelDates.scss';

const TravelDates = ({
  selectedSchemeType,
  singleDateDefinition,
  annualDateDefinition,
  tripTypeDefinition,
  isExpired,
  minEndDate,
  validateEnd,
  validateStart,
  maxAdvanceDays,
  maxDays,
  startDate,
  minAdvanceDays,
}) => {
  return (
    <div className={'sl-travel-dates'}>
      <SingleDates
        show={selectedSchemeType !== 'annual'}
        dateDefinition={singleDateDefinition}
        tripTypeDefinition={tripTypeDefinition}
        isExpired={isExpired}
        advanceDays={maxAdvanceDays.single}
        minAdvanceDays={minAdvanceDays.single}
        stat
        minDate={minEndDate}
        maxDays={maxDays}
        validateStart={validateStart}
        validateEnd={validateEnd}
        startDate={startDate}
      />
      <AnnualDates
        advanceDays={maxAdvanceDays.annual}
        show={selectedSchemeType === 'annual'}
        dateDefinition={annualDateDefinition}
        isExpired={isExpired}
        validateEnd={validateEnd}
      />
    </div>
  );
};
export default TravelDates;
